import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'serverOperativeState'
})
export class ServerOperativeStatePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    let serverOperativeStateIcon;

    if (value.toLowerCase() === 'available') {
      serverOperativeStateIcon = '<i class="fa fa-check-circle available" title="Available"></i>';
    } else {
      serverOperativeStateIcon = '<i class="fa fa-times-circle unavailable" title="Unavailable"></i>';
    }

    return `<div class="center-content">${serverOperativeStateIcon}</div>`;
  }
}
